export const AUDIENCE_TYPE = {
    FREE: 'free',
    PAID: 'paid',
} as const;
